import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { headings, paragraph, enter } from './animation.js'

gsap.registerPlugin(ScrollTrigger)

export const archive = () => {

	let el = document.querySelector('[data-sprig-container]'),
		entries = document.querySelector('[data-sprig-entries]')

	if (!el || !entries) return

	htmx.on('htmx:beforeRequest', (e) => {
		el = document.querySelector('[data-sprig-container]')
		entries = document.querySelector('[data-sprig-entries]')

		gsap.to(entries, {
			duration: 0.6,
			opacity: 0,
		})
	})

	htmx.on('htmx:afterSwap', () => {
		el = document.querySelector('[data-sprig-container]')
		entries = document.querySelector('[data-sprig-entries]')

		headings(el)
		paragraph(el)
		enter(el)

		gsap.fromTo(entries, {
			opacity: 0
		}, {
			opacity: 1,
			duration: 0.6,
		})
	})
}

export default () => { } 